import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Briefcase, Building2, GraduationCap, User } from "lucide-react";

const Icons = { ArrowRight, Briefcase, Building2, GraduationCap, User };

const AUDIENCES = [
  { to: "/for-clinics", icon: Icons.Building2, title: "Clinics", desc: "Structured intake, assessment, and reporting support for clinical teams." },
  { to: "/for-education", icon: Icons.GraduationCap, title: "Education", desc: "Student wellbeing support with privacy at the centre." },
  { to: "/for-companies", icon: Icons.Briefcase, title: "Companies", desc: "Wellbeing check-ins with clear ethical boundaries." },
  { to: "/for-individuals", icon: Icons.User, title: "Individuals", desc: "Guided self-reflection and structured summaries." },
];

export default function AudienceSection() {
  return (
    <section id="audiences" data-testid="audience-section" className="py-20 md:py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-12">
          <span className="inline-block text-xs font-semibold uppercase tracking-[0.18em] text-cyan-700 mb-3">
            Built for your context
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 font-['Plus_Jakarta_Sans'] leading-tight">
            Built for Multiple Care and Support Settings
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-600 leading-relaxed">
            PsyTech supports structured assessment workflows across clinics, education, companies, and individuals — with human oversight always in the loop.
          </p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {AUDIENCES.map((a) => (
            <Link
              key={a.to}
              to={a.to}
              onClick={() => window.__psyTrack && window.__psyTrack("button_click", { button: "audience-card", target: a.to })}
              data-testid={`audience-card-${a.to.replace("/for-", "")}`}
              className="group relative bg-white rounded-2xl border border-slate-200 p-6 hover:border-cyan-300 hover:shadow-xl hover:shadow-cyan-900/5 hover:-translate-y-0.5 transition-all"
            >
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-cyan-500/10 to-cyan-600/10 ring-1 ring-cyan-200 flex items-center justify-center mb-4">
                <a.icon className="w-5 h-5 text-cyan-700" />
              </div>
              <h3 className="text-lg font-semibold text-slate-900 font-['Plus_Jakarta_Sans'] mb-1.5">{a.title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{a.desc}</p>
              <div className="mt-4 inline-flex items-center gap-1 text-xs font-semibold text-cyan-700 group-hover:text-cyan-800">
                Learn more <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
